import { Trans, useLingui } from "@lingui/react";
import { SmabatAlert } from "src/client/components/SmabatAlert.tsx";
import { TradeOrgPages } from "src/types/tradeorgPages.ts";
import { useAppConfig } from "../context/AppConfigProviderContext.tsx";
import Title from "./components/Title.tsx";
import { Layout } from "./Layout.tsx";

const Smabatregisteret = () => {
  const { i18n } = useLingui();
  const { assetsBaseUrl, smallBoatState } = useAppConfig();
  const pageName = TradeOrgPages.Smabatregisteret;

  const pageTitle = i18n._({
    id: "tradeOrgLayout.page.smabatregisteret.title",
    message: "Småbåtregisteret – drevet av Redningsselskapet",
    comment: "Page title with trade organization name",
  });

  return (
    <Layout
      left={
        <>
          <Title title={pageTitle} />
          <SmabatAlert smallBoatState={smallBoatState} />
          <div className="mt-40">
            <div className="mt-40 pb-40 border-b md:border-none">
              <h4 className="t4 mb-0">
                <Trans
                  id="tradeOrgLayout.smabatregisteret.section.one.text.title"
                  message="A registered boat is an identifiable boat. This is important for you because:"
                  comment="Do not edit the translation submitted. Pre-approved text, must not deviate."
                />
              </h4>
              <ul className="mt-16 mb-0 pl-32 list-outside list-disc">
                <li className="mb-16">
                  <Trans
                    id="tradeOrgLayout.smabatregisteret.section.one.text.partOne"
                    message="Security when buying and selling – easy to identify the rightful owner"
                    comment="Do not edit the translation submitted. Pre-approved text, must not deviate."
                  />
                </li>

                <li className="mb-16">
                  <Trans
                    id="tradeOrgLayout.smabatregisteret.section.two.text.partTwo"
                    message="The Joint Rescue Coordination Centre, The Norwegian Sea Rescue Society and the emergency services have direct access to the Small Boat Register"
                    comment="Do not edit the translation submitted. Pre-approved text, must not deviate."
                  />
                </li>

                <li className="mb-16">
                  <Trans
                    id="tradeOrgLayout.smabatregisteret.section.three.text.partThree"
                    message="The Small Boat Register is an important tool for tracking down boats and boat owners"
                    comment="Do not edit the translation submitted. Pre-approved text, must not deviate."
                  />
                </li>

                <li className="mb-16">
                  <Trans
                    id="tradeOrgLayout.smabatregisteret.section.four.text.partFour"
                    message="Most insurance companies require registration"
                    comment="Do not edit the translation submitted. Pre-approved text, must not deviate."
                  />
                </li>

                <li className="mb-16">
                  <Trans
                    id="tradeOrgLayout.smabatregisteret.section.five.text.partFive"
                    message="Many of the country's ports and boat associations require registration"
                    comment="Do not edit the translation submitted. Pre-approved text, must not deviate."
                  />
                </li>

                <li className="mb-16">
                  <Trans
                    id="tradeOrgLayout.smabatregisteret.section.six.text.partSix"
                    message="The surplus in the Small Boat Register goes to the work of the The Norwegian Sea Rescue Society"
                    comment="Do not edit the translation submitted. Pre-approved text, must not deviate."
                  />
                </li>

                <li>
                  <Trans
                    id="tradeOrgLayout.smabatregisteret.section.seven.text.partSeven"
                    message="With a registered boat, you contribute to safety and well-being at sea"
                    comment="Do not edit the translation submitted. Pre-approved text, must not deviate."
                  />
                </li>
              </ul>
            </div>
          </div>
        </>
      }
      right={
        <div className="mt-40 md:mt-0 pb-40 md:pb-0">
          <img
            src={`${assetsBaseUrl}/assets/${pageName}_logo.png`}
            alt={`${pageName}-logo`}
            className="p-4"
            height="78"
            width="170"
            style={{ backgroundColor: "#264195", margin: "auto" }}
          />
          <p className="mt-16 mb-0">
            <Trans
              id="tradeOrgLayout.smabatregisteret.section.right.text.partOne"
              message="Småbåtregisteret is Norway's largest boat register for boats up to 15 meters."
              comment="Do not edit the translation submitted. Pre-approved text, must not deviate."
            />
          </p>
          <p className="mt-16 mb-0">
            <Trans
              id="tradeOrgLayout.smabatregisteret.section.right.text.partTwo"
              message="Important entities that have 24/7 access to the Small Boat Register include:"
              comment="Do not edit the translation submitted. Pre-approved text, must not deviate."
            />
          </p>
          <ul className="mt-16 mb-0 pl-32 list-outside list-disc">
            <li className="mb-16">
              <Trans
                id="tradeOrgLayout.smabatregisteret.section.right.bullet.pointOne"
                message="The Joint Rescue Coordination Centre (which have the overall operational responsibility for search and rescue operations)"
                comment="Do not edit the translation submitted. Pre-approved text, must not deviate."
              />
            </li>
            <li className="mb-16">
              <Trans
                id="tradeOrgLayout.smabatregisteret.section.right.bullet.pointTwo"
                message="The police"
                comment="Do not edit the translation submitted. Pre-approved text, must not deviate."
              />
            </li>
            <li className="mb-16">
              <Trans
                id="tradeOrgLayout.smabatregisteret.section.right.bullet.pointThree"
                message="The Norwegian Sea Rescue Society"
                comment="Do not edit the translation submitted. Pre-approved text, must not deviate."
              />
            </li>
            <li className="mb-16">
              <Trans
                id="tradeOrgLayout.smabatregisteret.section.right.bullet.pointFour"
                message="The port authority"
                comment="Do not edit the translation submitted. Pre-approved text, must not deviate."
              />
            </li>
            <li>
              <Trans
                id="tradeOrgLayout.smabatregisteret.section.right.bullet.pointFive"
                message="The insurance companies"
                comment="Do not edit the translation submitted. Pre-approved text, must not deviate."
              />
            </li>
          </ul>
        </div>
      }
    />
  );
};

export default Smabatregisteret;
